import { render, staticRenderFns } from "./KillSelfSabotageTrackker.vue?vue&type=template&id=66450997&scoped=true&"
import script from "./KillSelfSabotageTrackker.vue?vue&type=script&lang=js&"
export * from "./KillSelfSabotageTrackker.vue?vue&type=script&lang=js&"
import style0 from "./KillSelfSabotageTrackker.vue?vue&type=style&index=0&id=66450997&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66450997",
  null
  
)

export default component.exports